/**
 * Generic copy function that provides a copy function to trigger on completion of method.
 *
 * @param value String to be copied to clipboard.
 * @param onCopy Method that is called after the copy has been made.
 */
export const copyToClipboard = (value: Nullable<string>, onCopy?: Nullable<() => void>): void => {
    if (value) {
        // Copy to clipboard.
        navigator.clipboard.writeText(value)
        if (onCopy) {
            onCopy()
        }
    }
}
